import { render, staticRenderFns } from "./paypay.vue?vue&type=template&id=22db2b8b&scoped=true"
import script from "./paypay.vue?vue&type=script&lang=js"
export * from "./paypay.vue?vue&type=script&lang=js"
import style0 from "./paypay.vue?vue&type=style&index=0&id=22db2b8b&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22db2b8b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22db2b8b')) {
      api.createRecord('22db2b8b', component.options)
    } else {
      api.reload('22db2b8b', component.options)
    }
    module.hot.accept("./paypay.vue?vue&type=template&id=22db2b8b&scoped=true", function () {
      api.rerender('22db2b8b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/pay/paypay.vue"
export default component.exports